import { createContext, useEffect, useState } from "react";

const AppContext = createContext();
const Provider = ({ children }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = localStorage.getItem("items");
    console.log(getData);
    if (getData) {
      setData(JSON.parse(getData));
    }
  }, []);
  return (
    <AppContext.Provider value={{ items: data, setData }}>
      {children}
    </AppContext.Provider>
  );
};
export { Provider, AppContext };
